﻿export * from './admin.component';
export * from './update-admin.component';